import * as React from 'react';
import styles from './element-loader.scss';

export const ElementLoader = () => (
  <div className={`${styles.elementLoader} element-loader`}>
    <ul className={styles.elementLoading}>
      <li/>
      <li/>
      <li/>
    </ul>
  </div>
);
